
const INITIAL_STATE = {
    allPermissions: [],
};

const PermissionsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ALL_PERMISSIONS':
            return {
                ...state,
                allPermissions: action.payload.allPermissions,
            };
        default:
            return state;
    }
};

export default PermissionsReducer;